import {ChangeDetectionStrategy, Component, inject, Injectable, Input, signal, TemplateRef, ViewChild} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MAT_DIALOG_DATA, MatDialog, MatDialogContent, MatDialogModule, MatDialogTitle, MatDialogRef} from '@angular/material/dialog';
import { CrudEditComponent } from '../crud/edit/edit.component';
import {MatCardModule} from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { CrudViewComponent } from '../crud/view/view';
import { CrudCreateComponent } from '../crud/create/create.component';
import { TITULOS_FIELDS_FORM, TITULOS_MOTIVOS_BAJA } from '../../../constants/titulos.constants';
import { Button } from "../button/button.component";
import { ACTION_TITTLES } from '../../../constants/actions.constants';
import { MatIconModule } from '@angular/material/icon';
import { TituloInterface } from '../../../models/titulo.model';
import { CommonModule, NgClass, NgTemplateOutlet } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ApiService } from '../../../core/api.service';

/**
 * @title Dialog with header, scrollable content and actions
 */
@Injectable({
  providedIn: 'root'
})
@Component({
  selector: 'app-modal',
  templateUrl: 'modal.html',
  imports: [MatButtonModule, MatDialogModule,MatFormFieldModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class Modal<T> {
  dialog = inject(MatDialog);
  action!:string
  actionTittles = ACTION_TITTLES;
  openDialog(action: string, id?: number, template?: TemplateRef<any>, showActionButtons: boolean = false, actionTittle?:string , modalSize: 'small' | 'medium' | 'large' = 'medium') {
    // Configuración base
    const widthMap: Record<string, string> = {
      small: '400px',
      medium: '800px',
      large: '1200px'
    };
    const maxWidthMap: Record<string, string> = {
      small: '90vw',
      medium: '95vw',
      large: '100vw'
    };
    const dialogConfig: any = {
      data: {
        action,
        id,
        tittle: this.actionTittles[action],
        templateRefContent: template,
        showActionButtons,
        actionTittles: this.actionTittles
      },
      width: widthMap[modalSize] || '1200px'
    };
    // if (action === 'viewInModal') {
      dialogConfig.maxWidth = maxWidthMap[modalSize] || '100vw';
      dialogConfig.width = widthMap[modalSize] || '1200px';
      dialogConfig.panelClass = 'view-in-modal-panel';
    // }
    return this.dialog.open(DialogDataExampleDialog, dialogConfig);
  }
}

@Component({
  selector: 'dialog-data-example-dialog',
  templateUrl: 'content.html',
  imports: [CrudEditComponent, MatCardModule, MatButtonModule, MatDialogModule, CrudCreateComponent, CrudViewComponent, MatIconModule, CommonModule, NgTemplateOutlet, Button, MatFormFieldModule, MatInputModule, MatSelectModule, FormsModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DialogDataExampleDialog<T> {
    trackByMotivo(index: number, item: any): any {
      return item && item.value ? item.value : index;
    }
  @ViewChild(CrudEditComponent) child!: CrudEditComponent<TituloInterface> | CrudCreateComponent<TituloInterface>;
  fields = TITULOS_FIELDS_FORM;
  data = inject(MAT_DIALOG_DATA);
  motivosBaja = TITULOS_MOTIVOS_BAJA;
  actionTittles = ACTION_TITTLES;
  tittleForCustomModal = signal('');
  constructor(public dialogRef: MatDialogRef<DialogDataExampleDialog<T>>) {}
  submit() {
    if (this.data.action === 'delete' || this.data.action === 'restore') {
      this.dialogRef.close({ action: this.data.action, id: this.data.id, motivo: this.data.motivo, comment: this.data.comment });
    }
    else {
      this.dialogRef.close({ action: this.data.action, id: this.data.id });
    }
  }
}
